import { Path } from "slate";
function filterForSubtreeRoots(entries) {
  return entries.filter(
    ([, nodePath]) => !Path.ancestors(nodePath).some((ancestor) => {
      return entries.some(([, path]) => Path.equals(path, ancestor));
    })
  );
}
export {
  filterForSubtreeRoots
};
//# sourceMappingURL=filterForSubtreeRoots.js.map